(function () {
  'use strict';

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function fallbackCopy(text) {
    return new Promise(function (resolve, reject) {
      var textarea = null;

      try {
        textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';
        textarea.style.top = '0';
        textarea.style.opacity = '0';

        document.body.appendChild(textarea);

        textarea.focus();
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);

        var successful = document.execCommand('copy');

        if (!successful) {
          throw new Error('Clipboard copy command failed');
        }

        resolve();
      } catch (error) {
        reject(error);
      } finally {
        if (textarea && textarea.parentNode) {
          textarea.parentNode.removeChild(textarea);
        }
      }
    });
  }

  function copyText(text) {
    text = String(text || '').trim();

    if (!text) {
      return Promise.reject(new Error('Nothing to copy'));
    }

    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () {
        return fallbackCopy(text);
      });
    }

    return fallbackCopy(text);
  }

  function getCopyContent(target) {
    if (!target) return '';

    if (target.matches('textarea, input')) {
      return String(target.value || '').trim();
    }

    if (target.matches('ul, ol')) {
      return Array.from(target.children)
        .filter(function (item) {
          return item.tagName === 'LI';
        })
        .map(function (item) {
          return String(item.innerText || item.textContent || '').trim();
        })
        .filter(Boolean)
        .join('\n');
    }

    return String(target.innerText || target.textContent || '').trim();
  }

  function initHub(root) {
    if (!root || root.dataset.tabsInitialized === 'true') return;

    root.dataset.tabsInitialized = 'true';

    var defaultSectionId = root.id + '-welcome';
    var productIndexId = root.id + '-products';
    var productPrefix = root.id + '-product-';
    var availableProductGuideId = root.id + '-product-l-methylfolate-15mg';

    var sections = Array.from(root.querySelectorAll('.ml-hub-section'));
    var navLinks = Array.from(root.querySelectorAll('.nav a[href^="#"]'));

    function sectionExists(sectionId) {
      return sections.some(function (section) {
        return section.id === sectionId;
      });
    }

    function getRequestedSectionId(hash) {
      var requestedId = String(hash || '').replace(/^#/, '');

      if (!requestedId || !sectionExists(requestedId)) {
        return defaultSectionId;
      }

      if (
        requestedId.indexOf(productPrefix) === 0 &&
        requestedId !== availableProductGuideId
      ) {
        return productIndexId;
      }

      return requestedId;
    }

    function updateNav(sectionId) {
      var navSectionId =
        sectionId.indexOf(productPrefix) === 0
          ? productIndexId
          : sectionId;

      navLinks.forEach(function (link) {
        link.classList.toggle(
          'active',
          link.getAttribute('href') === '#' + navSectionId
        );
      });
    }

    function showSection(hash, options) {
      options = options || {};

      var sectionId = getRequestedSectionId(hash);

      sections.forEach(function (section) {
        var active = section.id === sectionId;

        section.classList.toggle('is-active', active);
        section.setAttribute('aria-hidden', String(!active));
      });

      updateNav(sectionId);

      if (
        options.updateUrl !== false &&
        window.location.hash !== '#' + sectionId
      ) {
        history.pushState(null, '', '#' + sectionId);
      }

      if (options.scrollToTop !== false) {
        var top = root.getBoundingClientRect().top + window.scrollY;

        window.scrollTo({
          top: Math.max(0, top - 16),
          behavior: options.instant ? 'auto' : 'smooth'
        });
      }
    }

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');

      if (!link || !root.contains(link)) return;

      var targetId = link.getAttribute('href').slice(1);

      if (!sectionExists(targetId)) return;

      event.preventDefault();

      showSection('#' + targetId, {
        updateUrl: true,
        scrollToTop: true
      });
    });

    window.addEventListener('popstate', function () {
      showSection(window.location.hash, {
        updateUrl: false,
        scrollToTop: true,
        instant: true
      });
    });

    var searchInput = root.querySelector('[data-product-search]');
    var clearButton = root.querySelector('[data-product-search-clear]');

    var filterButtons = Array.from(
      root.querySelectorAll('[data-product-filter]')
    );

    var productCards = Array.from(
      root.querySelectorAll('[data-product-card]')
    );

    var categoryGroups = Array.from(
      root.querySelectorAll('[data-product-category]')
    );

    var resultCount = root.querySelector('[data-product-result-count]');
    var emptyState = root.querySelector('.product-search-empty');

    var activeCategory = 'all';

    function filterProducts() {
      if (!productCards.length) return;

      var term = normalize(searchInput && searchInput.value);
      var visibleCount = 0;

      productCards.forEach(function (card) {
        var matchesCategory =
          activeCategory === 'all' ||
          card.dataset.category === activeCategory;

        var matchesSearch =
          !term ||
          normalize(card.dataset.search).indexOf(term) !== -1;

        var visible = matchesCategory && matchesSearch;

        card.hidden = !visible;

        if (visible) visibleCount += 1;
      });

      categoryGroups.forEach(function (group) {
        group.hidden = !Array.from(
          group.querySelectorAll('[data-product-card]')
        ).some(function (card) {
          return !card.hidden;
        });
      });

      if (resultCount) {
        resultCount.textContent =
          visibleCount +
          (visibleCount === 1 ? ' product' : ' products');
      }

      if (clearButton) {
        clearButton.classList.toggle('is-visible', Boolean(term));
      }

      if (emptyState) {
        emptyState.classList.toggle(
          'is-visible',
          visibleCount === 0
        );
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', filterProducts);
    }

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        if (!searchInput) return;

        searchInput.value = '';
        searchInput.focus();

        filterProducts();
      });
    }

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeCategory = button.dataset.productFilter || 'all';

        filterButtons.forEach(function (item) {
          var active = item === button;

          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });

        filterProducts();
      });
    });

    filterProducts();

    // COPY BUTTONS
    root.addEventListener('click', function (event) {
      var copyButton = event.target.closest('[data-copy-target]');

      if (!copyButton || !root.contains(copyButton)) return;

      event.preventDefault();

      var selector = copyButton.dataset.copyTarget;

      if (!selector) {
        console.error('Copy target selector is missing');
        return;
      }

      var target = null;

      try {
        target = root.querySelector(selector);
      } catch (error) {
        console.error('Invalid copy target selector:', selector, error);
        return;
      }

      if (!target) {
        console.error('Copy target not found:', selector);
        return;
      }

      var text = getCopyContent(target);

      var label = copyButton.querySelector('[data-copy-label]');

      var originalLabel = label
        ? (label.dataset.originalLabel || label.textContent)
        : 'Copy';

      if (label) {
        label.dataset.originalLabel = originalLabel;
      }

      if (copyButton._copyTimeout) {
        window.clearTimeout(copyButton._copyTimeout);
      }

      function showCopyStatus(message) {
        if (label) {
          label.textContent = message;
        }

        copyButton.setAttribute('aria-live', 'polite');

        copyButton._copyTimeout = window.setTimeout(function () {
          if (label) {
            label.textContent = originalLabel;
          }

          copyButton.removeAttribute('aria-live');
        }, 2000);
      }

      if (!text) {
        showCopyStatus('Nothing to copy');
        return;
      }

      copyText(text)
        .then(function () {
          showCopyStatus('Copied!');
        })
        .catch(function (error) {
          console.error('Clipboard error:', error);
          showCopyStatus('Copy failed');
        });
    });

    // PRODUCT GUIDE
    var productGuide = root.querySelector('.pg-guide');

    if (productGuide) {
      var angleFilterButtons = Array.from(
        productGuide.querySelectorAll('[data-angle-filter]')
      );

      var angleCards = Array.from(
        productGuide.querySelectorAll('[data-content-angle]')
      );

      angleFilterButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var selected = button.dataset.angleFilter || 'all';

          angleFilterButtons.forEach(function (item) {
            var active = item === button;

            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });

          angleCards.forEach(function (card) {
            var formats = String(
              card.dataset.formats || ''
            ).split(/\s+/);

            card.hidden =
              selected !== 'all' &&
              formats.indexOf(selected) === -1;
          });
        });
      });

      var guideNavLinks = Array.from(
        productGuide.querySelectorAll(
          '.pg-sticky-links a[href^="#"]'
        )
      );

      var guideAnchors = guideNavLinks
        .map(function (link) {
          return root.querySelector(link.getAttribute('href'));
        })
        .filter(Boolean);

      if ('IntersectionObserver' in window && guideAnchors.length) {
        var guideObserver = new IntersectionObserver(
          function (entries) {
            var visible = entries
              .filter(function (entry) {
                return entry.isIntersecting;
              })
              .sort(function (a, b) {
                return (
                  a.boundingClientRect.top -
                  b.boundingClientRect.top
                );
              });

            if (!visible.length) return;

            var activeId = visible[0].target.id;

            guideNavLinks.forEach(function (link) {
              link.classList.toggle(
                'is-active',
                link.getAttribute('href') === '#' + activeId
              );
            });
          },
          {
            rootMargin: '-125px 0px -68% 0px',
            threshold: 0
          }
        );

        guideAnchors.forEach(function (anchor) {
          guideObserver.observe(anchor);
        });
      }
    }

    showSection(window.location.hash, {
      updateUrl: false,
      scrollToTop: false
    });
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll(
        '.ml-affiliate-hub[data-ml-affiliate-hub]'
      )
      .forEach(initHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();